import { Injectable, signal } from '@angular/core';
import BuildInfoJson from '../../../../assets/build.info.json';

@Injectable({
  providedIn: 'root',
})
export class BuildInfoService {
  public buildId = signal<string>('');
  public buildVersion = signal<string>('');
  public isNewVersionAvailable = signal<boolean>(false);

  private readonly VERSION_STORAGE_KEY = 'tourfold-app-build-id';

  constructor() {
    // Build id
    this.buildId.set(BuildInfoJson.build_id);

    // Version (for display purposes, but we'll use build_id for change detection)
    let buildVersion = BuildInfoJson.version;
    console.log('Build version:', buildVersion);
    console.log('Build ID:', BuildInfoJson.build_id);
    
    if (buildVersion?.trim()) {
      // Check if buildVersion contains 'release-' and remove it
      if (buildVersion.includes('release-')) {
        buildVersion = buildVersion.replace('release-', '');
      }
      this.buildVersion.set(buildVersion);
    } else {
      // Since version is empty, use build_id as display version
      this.buildVersion.set(BuildInfoJson.build_id);
    }

    // Check for version updates using build_id
    this.checkForVersionUpdate();
  }

  /**
   * Checks if the current build_id is different from the previously stored build_id
   */
  private checkForVersionUpdate(): void {
    const currentBuildId = this.buildId();
    let storedBuildId: string | null = null;
    try{
      storedBuildId = localStorage.getItem(this.VERSION_STORAGE_KEY);
    }catch(e){
      console.error('Error getting stored build id', e);
    }

    if (storedBuildId && storedBuildId !== currentBuildId) {
      this.isNewVersionAvailable.set(true);
      console.log('New build detected:', currentBuildId, 'Previous:', storedBuildId);
    }

    try{
      // Always update the stored build_id to current
      localStorage.setItem(this.VERSION_STORAGE_KEY, currentBuildId);
    }catch(e){
      console.error('Error setting stored build id', e);
    }
  }

  /**
   * Call this method when the user acknowledges the version update
   * (e.g., when they dismiss the update notification)
   */
  public acknowledgeVersionUpdate(): void {
    this.isNewVersionAvailable.set(false);
  }

  /**
   * Get the previous build_id from storage
   */
  public getPreviousBuildId(): string | null {
    return localStorage.getItem(this.VERSION_STORAGE_KEY);
  }

}
